import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import "./Increment_Decrement_Btn.css";

const Increment_Decrement_Btn_Simple = ({
  quantity,
  setQuantity,
  ...props
}) => {
  const [Errors, setErrors] = useState(null);

  const cartQuantity = (type) => {
    setErrors(null); // reset errors on each click

    setQuantity((prevQuantity) => {
      if (type === "minus") {
        if (prevQuantity > 1) return prevQuantity - 1;
        setErrors("Quantity cannot be less than 1");
        return prevQuantity; // do not decrease below 1
      } else if (type === "add") {
        return prevQuantity + 1;
      }
      return prevQuantity;
    });
  };

  return (
    <>
      <div className="Increment_Decrement_Btn">
        <div className="main_content_holder">
          {/* Decrement Button */}
          <div className="icon_holder" onClick={() => cartQuantity("minus")}>
            <FontAwesomeIcon icon={faMinus} className="icon_class" />
          </div>

          <div className="count_holder">
            <p className="count">{quantity}</p>
          </div>

          <div
            className="icon_holder"
            onClick={() => {
              if (Number(quantity) >= Number(props.varient?.general_stock)) {
                setErrors("Out of Stock");
              } else if (
                props?.product?.allowed_quanitity &&
                Number(quantity) >= Number(props.product.allowed_quanitity)
              ) {
                setErrors(
                  `You can only buy max ${props.product.allowed_quanitity}`
                );
              } else {
                setErrors("");
                cartQuantity("add");
              }
            }}
          >
            <FontAwesomeIcon icon={faPlus} className="icon_class" />
          </div>
        </div>

        {Errors && <p className="Increment_Decrement_error" style={{ color: "red" ,fontSize: "11px" }}>{Errors}</p>}
      </div>
    </>
  );
};

export default Increment_Decrement_Btn_Simple;
